<template>
  <div class="resume-box">
    <div class="title">
      <span>简历上需要写兴趣爱好吗？</span>
      <div class="title-end"></div>
    </div>
    <p class="content-item">
      首先，突出一两项特长或者和求职岗位相关的兴趣爱好即可；
    </p>
    <p class="content-item">
      其次，和其他部分的经历描述一样，要具体清晰，不要写：阅读，音乐，旅游，这种描述；
    </p>
    <p class="content-item">
      最后，与求职意向相关的爱好优先。
    </p>
    <p class="ps" @click="$router.push('/cvs')">Get！去修改简历 > </p>
  </div>
</template>

<script>
  export default {
    name: "Resume"
  }
</script>

<style scoped lang="scss">
.resume-box{
  padding: 30px 24px 60px 24px;
  position: relative;
  box-sizing: border-box;
  .title{
    font-size: 18px;
    font-weight: 500;
    color: #D5C3FF;
    line-height: 25px;
    position: relative;
    text-align: center;
    width: 100%;
    margin-bottom: 34px;
    .title-end{
      width: 226px;
      height: 13px;
      background: rgba(195, 169, 255, 0.2);
      border-radius: 7px;
      position: absolute;
      bottom: -4px;
      left: 50%;
      transform: translateX(-50%);
    }

  }
  .content-item{
    width: 299px;
    font-size: 14px;
    font-weight: 400;
    color: #D5C3FF;
    line-height: 20px;
    margin-bottom: 10px;
  }
  .ps{
    width: 180px;
    height: 44px;
    background: linear-gradient(180deg, #EDC639 0%, #EC890E 100%);
    border-radius: 24px;
    text-align: center;
    line-height: 44px;
    bottom: -6px;
    color: #fff;
    font-weight: 600;
    font-size: 16px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>